/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Schule_Am_Ried2Inputs */

const en__field_enum_schule_am_ried2 = /** @type {(inputs: _Field_Enum_Schule_Am_Ried2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field_enum_schule_am_ried2 = /** @type {(inputs: _Field_Enum_Schule_Am_Ried2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schule-am-Ried`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field_Enum_Schule_Am_Ried2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_schule_am_ried2 = /** @type {((inputs?: _Field_Enum_Schule_Am_Ried2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Schule_Am_Ried2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_schule_am_ried2(inputs)
	return de__field_enum_schule_am_ried2(inputs)
});
export { _field_enum_schule_am_ried2 as "_field_enum_Schule_am_Ried" }